export default __webpack_public_path__ + "static/media/Nicole_9781408304747.8283e87c.jpg";